export default __webpack_public_path__ + "static/media/f15-my-documents.70b3f58f.svg";